import './projects.css'

export default function Projects () {
  return (
    <div className="projects-container">
      <h3 className="skills-header">
        Projects
      </h3>
        <div
          className="project-contributions-inner-container"
        >
          <div className="pc">
            <div className="spread-out">
              <h3 id="header-color" className="no-margin">
                Poob 
              </h3>

              {/* <a href="https://github.com/nicgauer/goodra"><GitHub /></a> */}
            </div>

            <p>
              A Search Engine inspired by the early yahoo and google search engines.  
              Built using Typescript, Express, Sequelize Postgres, Docker, nginx, HTML, and CSS.  Hosted in a Digital Ocean droplet.    
              An exporation into webscraping and indexing, queries, and building something as lightweight and cheap as possible to host and maintain.  
              No UI frameworks used!
            </p>

            <p>
              Poob uses a collection of lightweight microservices to scrape and index the web, and another to allow users to search it's collection and view results in a paginated view.  
              We typically are running anywhere from 2-5 scraping instances at a time with a single database and API instance.
            </p>

            <h5>
              Visit the application at <a href={"https://www.poob.website"}>www.poob.website</a>
            </h5>

          </div>
          <div
            className="pc"
          >
            <div 
              className="spread-out"
            >
              <h3 id="header-color" className="no-margin">
                Shitr 💩
              </h3>

              {/* <a href="https://github.com/nicgauer/jigglypuff"><GitHub /></a> */}
            </div>

            <p>
              A simple microblogging application inspired by the golden age of Twitter.    
              Shitr has everything you'd expect from a modern microblogging application: 
            </p>

            <ul className="central-inner-list">
              <li>
                Basic authentication and user roles
              </li>
              <li>
                Text Posts with link preview support and integrated players for YouTube and Bandcamp links
              </li>
              <li>
                Image uploads and a complete Image Editor made with the HTML Canvas for Premium users
              </li>
              <li>
                Full social loop including following other users, standard post interactions including likes, replies, reposts and quote posts, along with notifications
              </li>
              <li>
                Live-Updating Private Messages for Premium Users using server side events
              </li>
              <li>
                Live-Updating Notification counts using server side events
              </li>
              <li>
                AtProtocol integration for extra content, including news feeds and mirrored Bluesky accounts
              </li>
              <li>
                User Profile Cusomization like custom display names, profile pictures, and bios
              </li>
              <li>
                Moderation tools including blocking users and admin ability to hide posts and deactivate accounts
              </li>
              <li>
                Expansive automated test suite and CI/CD pipeline for rapid and consistent development
              </li>
            </ul>

            <p className="description">
              Built using TypeScript, React, NextJS, Payload CMS, Jest, Playwright, Docker, and SQLite.  Hosted on a Digital Ocean droplet using a Github Action based CI/CD.  
            </p>

            <p>
              <span style={{fontWeight: 'bold', marginRight: '4px'}}>
                Content Warning: 
              </span>
              Shitr has an active community of real users.  Anyone can join and post.  
              The content of the site is not moderated.
            </p>

            <h5>
              Visit the application at <a href={"https://www.shitr.app"}>www.shitr.app</a>
            </h5>
          </div>
        </div>

      <h3
          className="skills-header"
        >
          Project Contributions
        </h3>

        <div
          className="project-contributions-inner-container"
        >
          <div
            className="pc"
          >
            <div 
              className="spread-out"
            >
              <h3 id="header-color" className="no-margin">
                EverServe
              </h3>

              <span
                className="date-span"
              >
                June 2025 - Current
              </span>

            </div>

            <p className="description">
              Built during my time with Everblue.  A web hosted application designed to facilitate the application to and management of government programs HOMES, HEAR, and WAP in multiple states.  
              Using role based access management, EverServe allows for Reviewers, Contractors, and Homeowners to all manage the facilitation of these government aid programs all on one application.
            </p>

            <p className="description">
              Built using Typescript, React, NextJS, Payload CMS, Docker, and PostgreSQL
            </p>

            <span
              className="pc-mini-header"
            >
              Notable Features I developed
            </span>

            <ul className="central-inner-list">
              <li>
                Designed and Implemented an automated testing suite using Jest and Playwright on a large, pre existing codebase that had no automated testing
              </li>
              <li>
                as a Tech Lead, Helped redesign and refactor codebase into new tech to improve scalability and code accuracy
              </li>
              <li>
                Lead expansion of project from managing a single program in a single state into a technology solution that can manage multiple programs in multiple states 
              </li>
              <li>
                Wrote and managed infrastructure such as database integrity, automated deployments to AWS and the NPM Package Registry, CI/CD, and various local development tooling to improve team efficency
              </li>
              <li>
                React-based PDF generation and download
              </li>
              <li>
                Handled database management such as migration and seed files across all environments
              </li>
              <li>
                Created CI/CD systems for deployments, releases, and automated testing
              </li>
            </ul>
          </div>


          <div
            className="pc"
          >
            <div 
              className="spread-out"
            >
              <h3 id="header-color" className="no-margin">
                Fennec
              </h3>
                          
              <span
                className="date-span"
              >
                May 2022 - March 2025
              </span>
            </div>
              <p
                className="description"
              >
                A cloud-hosted enterprise software for Medical Insurance Claim Review developed for and sold to our client, 
                <a target="_blank" rel="noreferrer" href="https://www.6degreeshealth.com/">6 Degrees Health</a>, developed by Xorfox.  Fennec was a collection of back-end microservices built in Spring, connected via Kafka, along with two separate Angular applications for UI.  It featured a host of data entry features, including importing from various file types, and a suite of customizable automatic review features that set the product apart.  Built by a team of 5 developers, and I was the first full time developer on this project.
              </p>

              <p>
                Built using Angular, SpringBoot, PostgreSQL, Kafka, Keycloak, and various smaller libraries including ApachePDFBox, Material UI, Hibernate,  and Flyway.  Dockerized and then hosted in AWS EC2 and S3 Instances, and managed using Docker Swarm mode.
              </p>
              
              <span
                className="pc-mini-header"
              >
                Notable Features I developed
              </span>
              <ul className="central-inner-list">

                <li>
                  Front end and back end Data Entry flow for most of the Application’s Data entry features, including UB04 manual entry, Claim manual entry, Provider information, and Medical Code entry and a feature to import Medical Codes and Medical Providers from external resources
                </li>
                <li>
                  PDF generation for client facing documents, including invoices.  Some of these PDFs acted as the final product for the system.
                </li>
                <li>
                  Initial dockerization of Angular projects with hot reload.  Initial 
                </li>
                <li>
                  File upload and download to S3
                </li>
                <li>
                  Role Based Authentication using Keycloak
                </li>
                <li>
                  Global SCSS styles, Material UI custom element styling
                </li>
                <li>
                  Unit Tests for Angular front-end and Spring back end, End to End tests using Selenium
                </li>
                <li>
                  Contributed to the creation of the initial stack and development environment using Docker, Terraform, Jenkins, and AWS
                </li>
                <li>
                  Automated Email notifications
                </li>
                <li>
                  Followed and enforced HIPPA Compliance fundamentals and training throughout development and sale
                </li>
              </ul>
          </div>

          <div
            className="pc"
          >
            <div 
              className="spread-out"
            >
              <h3 id="header-color" className="no-margin">
                Drawbridge
              </h3>
                          
              <span
                className="date-span"
              >
                August 2024 - March 2025
              </span>
            </div>


            <p className="description">
              An authentication solution offering OAuth and SCIM services developed during my time with Xorfox.  Drawbridge was a Quarkus backend alongside a heavily modified Keycloak instance with an Angular UI.  
              Users would use the UI to pay for and create Keycloak Realms that we would then host inside of Drawbridge that the Users could use for authentication, OAuthm and SCIM.  
              Alongside the software, the Drawbridge team offered a hosting service as an AWS Reseller, and a self-hostable version of the sofware.  
            </p>
            
            <p>
              Built using Quarkus, Angular, Docker, PostgreSQL, and Keycloak
            </p>

            <ul className="central-inner-list">
              <li>
                Global SCSS Styles
              </li>
              <li>
                Role Based Authentication of the Angular UI using Keycloak
              </li>
              <li>
                CSS generator for custom styling of the clients’ login and management screens
              </li>
              <li>
                Full Stack data entry features that allowed users to create and maintain Keycloak Realms
              </li>
            </ul>
          </div>

          <div
            className="pc"
          >
            <div 
              className="spread-out"
            >
              <h3 id="header-color" className="no-margin">
                SOBRsafe Dashboards
              </h3>
                          
              <span
                className="date-span"
              >
                August 2024 - March 2025
              </span>
            </div>

            <p className="description">
              Developed an alpha and beta product for the company <a target="_blank" rel="noreferrer" href="https://sobrsafe.com/" >SOBRsafe</a> during my time with Xorfox.  
              SOBRsafe produces high-tech alcohol detection devices, essentially breathalyzers that do not require blowing.  Our product was a unified dashboard app where companies could monitor many devices at one time using dynamic charts and graphs.  
              Included the generation of customizable PDF reports.
            </p>
            
            <p>
              Built using Spring, Angular, Docker, PostgreSQL, and Keycloak
            </p>

            <ul className="central-inner-list">
              <li>
                Google Maps display of up-to-date device location
              </li>
              <li>
                Role Based Authentication of the Angular UI using Keycloak
              </li>
              <li>
                Several live-updating charts and graphs using a combination of libraries like Apache ECharts and raw SCSS/Typescript
              </li>
              <li>
                A detailed PDF Report Generation system using Angular and SCSS to create beautiful client facing reports
              </li>
            </ul>
          </div>


          <div
            className="pc"
          >
            <div 
              className="spread-out"
            >
              <h3 id="header-color" className="no-margin">
                Open Elis Instrument Interface
              </h3>
                          
              <span
                className="date-span"
              >
                June 2021 - June 2022
              </span>
            </div>

            <p className="description">
              Developed an alpha product for the <a target="_blank" rel="noreferrer" href="https://openelis-global.org/" >Open Elis</a> organization during my time with Xorfox.  
              Our product was a web hosted data conversion solution that was designed to translate data from machines to the Open Elis software.  
            </p>
            
            <p>
              Built using Spring, React, Docker, PostgreSQL, and Keycloak
            </p>

            <ul className="central-inner-list">
              <li>
                Full Stack Data Entry features that allowed users to translate CSV files from one format to another
              </li>
              <li>
                Role Based Authentication of the React UI using Keycloak
              </li>
              <li>
                File upload and business logic that produced altered files
              </li>
            </ul>
          </div>


        </div>
    </div>
  )
}